import PersonalizedUsersPage from "../../../features/admin/personalized-users/personalized-users-page";

export default function PersonalizedUsers() {
  return <PersonalizedUsersPage />;
}
